import React from "react"

import { RouteComponentProps } from "react-router-dom"

import { tutorClient } from "src/graphql-config"
import { MatchParams } from "src/types"

import TailoredAssignmentPreview from "components/TailoredAssignmentPreview"

const TutorAssignmentPreview: React.FC<RouteComponentProps<MatchParams>> = ({
  match,
}) => {
  const { id } = match.params
  return <TailoredAssignmentPreview id={id} client={tutorClient} />
}

export default TutorAssignmentPreview
